import { storage } from "lib";
import { useCallback, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { Alert } from 'components/elements';
import alert from "components/elements/Alert";
import useConfig from "features/config/hooks/useConfig";
import { getEmploymentInformation, getCountNotification } from 'features/employee/services/employeeApi';
import { ReactComponent as NotificationIcon } from "assets/icon/notificationIcon.svg"
import { setCurrentEmploymentHome } from 'features/employee/slices/employeeSlice';
import { generateRandomString } from 'utils/helper';
import { fetchCompany, rolePermissionByEmpId, updateFcmToken } from "../services/companyApi";
import {
  setCompanyList,
  setCurrentCompany,
  setCurrentEmployee,
  setIsLoading,
  setNotification,
  setRoles,
} from "../slices/companySlice";
import { Badge } from "antd";
import Notification from "components/layouts/MainLayout/Notification";
import useFirebaseNoti from "lib/useFirebaseNoti";

const modifyCompany = (companyList = [], lang = "en") => {
  const modifiedOptions = companyList.map((opt) => ({
    ...opt,
    label: lang === "en" ? (opt?.companyNameEn ? opt.companyNameEn : opt.companyName) : opt.companyName,
    value: opt.companyId,
    employeeId: opt.employeeId,
  }));
  console.log("modifiedOptions", modifiedOptions);

  return modifiedOptions;
};

function useCompany() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const isLoading = useSelector((state) => state.company.isLoading);
  const { profile } = useSelector((state) => state.login);
  const companyList = useSelector((state) => state.company.companyList);
  const { currentCompany, currentEmployee, roles, notification, fcmToken } = useSelector((state) => state.company);
  const { onThemeChange } = useConfig();
  // const { fetchToken, getCountNotificationFn } = useFirebaseNoti()

  const modifiedCompanyList = useMemo(() => {
    return modifyCompany(companyList, i18n.language);
  }, [i18n.language, companyList]);

  const handleTheme = useCallback(
    (company) => {
      const foundCompany = modifiedCompanyList.find((c) => c.value === company);
      if (foundCompany) {
        onThemeChange(foundCompany);
      }
    },
    [modifiedCompanyList, onThemeChange]
  );

  const handleChange = useCallback(
    (value) => {
      dispatch(setCurrentCompany(value));
      storage.localStorage.setItem("currentCompany", value);
      const foundCompany = companyList.find((c) => c.companyId === value);
      if (foundCompany) {
        dispatch(setCurrentEmployee(foundCompany.employeeId));
        storage.localStorage.setItem("currentEmployee", foundCompany.employeeId);
      }
      handleTheme(value);
    },
    [dispatch, handleTheme]
  );

  const getCompanyOptions = useCallback(
    async (cb = () => { }) => {
      try {
        dispatch(setIsLoading(true));
        const response = await fetchCompany();
        dispatch(setCompanyList(response?.data));
        console.log("response.data", response?.data);
        cb(modifyCompany(response?.data, i18n.language));
      } catch (error) {
        console.log("eerrr", error);

        // alert({
        //   type: "error",
        //   message: "Get company failed, Redirect Back to signin page.",
        //   resultObject: error,
        // });
        navigate("/login");
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [i18n.language, dispatch, navigate]
  );

  const getRolePermissionByEmpId = useCallback(
    async () => {
      // console.log("getRolePermissionByEmpId", currentEmployee);
      if (currentEmployee) {
        try {
          dispatch(setIsLoading(true));
          const response = await rolePermissionByEmpId({ employeeId: currentEmployee });
          dispatch(setRoles(response.data));
        } catch (error) {
          // alert({
          //   type: "error",
          //   message: "Get company failed, Redirect Back to signin page.",
          //   resultObject: error,
          // });
        } finally {
          dispatch(setIsLoading(false));
        }
      }
    },
    [currentEmployee]
  );

  const getEmploymentInfoCallback = useCallback(
    async () => {
      try {
        dispatch(setIsLoading(true));
        const response = await getEmploymentInformation({
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: currentEmployee,
          visible: false,
          edit: false
        });
        dispatch(setCurrentEmploymentHome(response.data || {}));
      } catch (error) {
        // Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentEmployee]
  );

  const getNotificationBadge = useCallback(() => {
    return <Notification notification={notification} />
  }, [notification]);


  const updateFcmTokenAfterLogin = useCallback(async () => {
    try {
      console.log("updateFcmTokenAfterLogin ");
      const response = await updateFcmToken({
        companyId: currentCompany,
        employeeId: currentEmployee,
        actionId: currentEmployee,
        fcmTokenFlowHr: fcmToken
      });
    } catch (error) {
      console.log("error ", error);
    }
  }, [currentCompany, currentEmployee, fcmToken])


  useEffect(() => {
    if (currentCompany) {
      // fetchToken()
      // getCountNotificationFn()
    }
  }, [currentCompany])

  useEffect(() => {
    if (currentCompany) {
      getNotificationBadge()
    }
  }, [notification])

  useEffect(() => {
    if (fcmToken && currentCompany) {
      updateFcmTokenAfterLogin()
    }
  }, [updateFcmTokenAfterLogin])


  return {
    isLoading,
    companyList: modifiedCompanyList,
    currentCompany,
    currentEmployee,
    handleChange,
    getCompanyOptions,
    getRolePermissionByEmpId,
    getEmploymentInfoCallback,
    getNotificationBadge
  };
}

export default useCompany;
